// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__30iAP","choiceBoxes":"toolbarselects_choiceBoxes__21uQu","simpleField":"toolbarselects_simpleField__1bfYM"};